import styled from "styled-components";
import colors from "../../styles/colors";

export const Container = styled.div`
  flex: 1;
`;

export const Title = styled.h1`
  font-size: 23px;
  margin-bottom: 32px;
`;

export const FormGroup = styled.div`
  padding-bottom: 40px;
  margin-bottom: 40px;
  border-bottom: 1px #191919 solid;
`;

export const InputGroup = styled.div`
  display: flex;
  margin-bottom: 16px;

  @media screen and (max-width: 480px) {
    flex-direction: column;
    margin-bottom: 0;
    input {
      margin-bottom: 16px;
    }
  }
`;

export const SubmitButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  background-color: ${colors.green};
  color: #000;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 18px;
  padding: 16px 24px;
  margin-top: 32px;
  transition: 300ms ease;

  :hover {
    transform: scale(0.95);
  }

  @media screen and (max-width: 480px) {
    width: 100%;
  }
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #141515;
  max-width: 640px;
  width: 100%;
  max-height: calc(100vh - 4rem);
  margin: 0 auto;
  padding: 32px;
  border-radius: 6px;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.05);
  overflow-y: auto;
  h3 {
    margin-bottom: 32px;
    text-align: center;
  }
  p {
    margin-bottom: 16px;
  }
`;

export const Checkbox = styled.label`
  label {
    display: flex;
    flex-direction: row;
    align-items: center;
    input {
      margin-right: 16px;
    }
    span.label {
      font-family: "Barlow", sans-serif;
      font-size: 16px;
      color: #fff;
    }
  }
`;

export const ModalTrigger = styled.span`
  color: ${colors.green};
  text-decoration: underline;
  cursor: pointer;
`;
